import { SecurityService } from 'app/security/security.service';
import { AuthService } from './../../auth/auth.service';
import { Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { EnrollmentProgramsService } from './enrollment-programs.service';
import { AppSettings } from 'app/shared/app-settings';
import { Injectable, Injector } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/src/toast-manager';
import { ViewContainerRef } from '@angular/core/src/linker/view_container_ref';
import { PasswordStrengthModel } from 'app/shared/validators/password-strength.model';

@Injectable()
export class StartupService {

  constructor(
    private injector: Injector) {

  }

  private errors: string[] = [];
  private currentThemeName: string;
  private vcrRef: ViewContainerRef;
  private toastr: ToastsManager;

  private _passwordConfig: PasswordStrengthModel;

  get passwordConfig() {
    return this._passwordConfig;
  }

  setup(): Promise<any> {
    let router = this.injector.get(Router),
        _authSer = this.injector.get(AuthService),
        hostPart = window.location.host.split('.')[0],
        isLaunch = window.location.pathname.indexOf('launch') > 0,
        promisesToExec = [];
    this.toastr = this.injector.get(ToastsManager);

    if (_authSer.isAuthenticated() && !isLaunch) {
      let _secService = this.injector.get(SecurityService);
      promisesToExec.push(_secService.loadUserInfo()
        .do(data => {
          this.currentThemeName = `${data.orgName.toLowerCase().replace(/\s/g, '_')}_theme`;
        })
        .catch((e) => {
          this.errors.push('Error in resolving current user');
          return Observable.of(e);
        }).toPromise())
    }
    else if (hostPart != 'www' && hostPart != 'app' && hostPart != AppSettings.devEnvAzureCanonicalAppName
      && hostPart.indexOf('localhost') < 0) {
      let _service = this.injector.get(EnrollmentProgramsService);
      promisesToExec.push(_service.getEnrolleProgramByAlias(hostPart).map((i) => {
        if (!i) {
          this.errors.push(`Cannot find program with alias ${hostPart}`);
          return;
        }
        router.navigate([`/security/${i.programAlias}/login`]);
        this.currentThemeName = `${i.orgName.toLowerCase().replace(/\s/g, '_')}_theme`;
      }).toPromise());
    }

    promisesToExec.push(System.import('../../../assets/configuration/config.json')
      .then((json) => {
        this._passwordConfig = json;
      }));

    return Promise.all(promisesToExec);
  }

  setVcr(vcr: ViewContainerRef) {
    this.vcrRef = vcr;
    this.showMessages();
    this.vcrRef.element.nativeElement.parentElement.className = this.currentThemeName;
  }

  private showMessages() {
    this.errors.forEach(m => {
      this.toastr.error(m, 'Error');
    })
  }

  setCurrentTheme(orgName?: string) {
    this.currentThemeName = `${(orgName || 'general').toLowerCase().replace(/\s/g, '_')}_theme`;
    if (!this.vcrRef)
      throw Error("Please set ViewContanerRef before changing theme...");
    this.vcrRef.element.nativeElement.parentElement.className = this.currentThemeName;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/startup.service.ts